export const APPLICATION = {
  OnlineTraining: 'OnlineTraining',
  SmartInsight: 'SmartInsight',
  TECloud: 'TECloud',
  ContainerHub: 'ContainerHub',
  ACSDFF: 'ACSDFF',
  AzureContainerHub: 'AzureContainerHub',

  Online_Training: 'OnlineTraining',
  Smart_Insight: 'SmartInsight',
  Container_Hub: 'ContainerHub',
  ACS_DFF: 'ACSDFF',
  Azure_Container_Hub: 'AzureContainerHub',
}